import React,{useEffect, useRef, useState} from "react";

export function UseRefTest() {
    /* 
    useRef 包裹了一下之后，与state中存的不一样，修改不会重渲染；
    并且重渲染之后值会保留，这一点与普通变量是有区别的，比如此例子中的countVar
    */
    const refCount = useRef(0);
    let countVar = 0;
    const [mutCount,setMutCount] = useState(0);
    const handleClick = () => {
        const count = refCount.current ++;
        console.log(`countVar:${countVar++},mutCount:${mutCount}`);
        alert(count);
        if(count%3 === 0) {
            setMutCount(mutCount+1);
        }
    }

    useEffect(()=>{
        console.log('UseRefTest,useEffect')
    });

    return <button onClick={handleClick}>UseRefTest Button</button>
}